import React, { createContext, useContext, useState, useMemo } from "react";

const FormContext = createContext(null);

export function FormProvider({ children }) {
    const [values, setValues] = useState({
        first_name: "",
        email: "",
        phone: "",
    });
    const [submitted, setSubmitted] = useState(false);

    const update = (patch) => setValues((v) => ({ ...v, ...patch }));

    const ctx = useMemo(
        () => ({ values, update, submitted, setSubmitted }),
        [values, submitted]
    );

    return <FormContext.Provider value={ctx}>{children}</FormContext.Provider>;
}

export function useSharedForm() {
    const ctx = useContext(FormContext);
    if (!ctx) throw new Error("useSharedForm must be used within FormProvider");
    return ctx;
}
